import React from 'react';

function Skills() {
    return (
        <>
            <section className="skills" id="skills">
                <div className="skills-text">
                    <div className="section-header">
                        <h2>SKILLS</h2>
                    </div>

                    <div className="card">
                        <div className="skill">
                            <h3>PROGRAMMING LANGUAGES</h3>
                            <h3 className="skill-names">TypeScript, JavaScript, C#, Python, SQL, HTML, CSS</h3>
                        </div>
                    </div>

                    <div className="card">
                        <div className="skill">
                            <h3>FRAMEWORKS & LIBRARIES</h3>
                            <h3 className="skill-names">.NET, React, Node.js, Express, Flask, SQLite3, numpy, pandas</h3>
                        </div>
                    </div>

                    <div className="card">
                        <div className="skill">
                            <h3>DATABASES</h3>
                            <h3 className="skill-names">Oracle, SQL Server, SQLite, MongoDB</h3>
                        </div>
                    </div>

                    <div className="card">
                        <div className="skill">
                            <h3>TOOLS</h3>
                            <h3 className="skill-names">Postman, Git, Visual Studio, NPM, Chrome Developer Tools</h3>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Skills